import { ButtonComponent } from './controls/button/button.component';
import { CardCamerasComponent } from './controls/card-cameras/card-cameras.component';
import { CardRoadSituationsComponent } from './controls/card-road-situations/card-road-situations.component';
import { CardTrafficComponent } from './controls/card-traffic/card-traffic.component';
import { CommonModule } from '@angular/common';
import { DragDropDirective } from '@ui-core/directives/drag-drop.directive';
import { DropdownComponent } from './controls/dropdown/dropdown.component';
import { DropFilesComponent } from '@ui-core/components/drop-files/drop-files.component';
import { DynamicFilterComponent } from './components/dynamic-filter/dynamic-filter.component';
import { DynamicSideMenuComponent } from './components/dynamic-side-menu/dynamic-side-menu.component';
import { FiltersComponent } from './components/filters/filters.component';
import { FooterComponent } from './components/footer/footer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridPageComponent } from './components/grid-page/grid-page.component';
import { GridTableComponent } from './controls/grid-table/grid-table.component';
import { HeaderComponent } from './components/header/header.component';
import { HorizontalMenuComponent } from './controls/horizontal-menu/horizontal-menu.component';
import { IconButtonComponent } from './controls/icon-button/icon-button.component';
import { IconComponent } from './controls/icon/icon.component';
import { SvgComponent } from './controls/svg-icon/svg.component';
import { ImgLoaderComponent } from './controls/img-loader/img-loader.component';
import { ListButtonsComponent } from './components/list-buttons/list-buttons.component';
import { LoaderOverlayComponent } from './components/loader-overlay/loader-overlay.component';
import { LocationSelectorComponent } from './components/location-selector/location-selector.component';
import { MapViewerComponent } from './components/map-viewer/map-viewer.component';
import { MaterialModule } from './shared/material.module';
import { MenuComponent } from './components/menu/menu.component';
import { ModalComponent } from './components/modal/modal.component';
import { ModalErrorComponent } from './components/modal-error/modal-error.component';
import { ModalImageComponent } from './components/modal-image/modal-image.component';
import { ModalNoInfoComponent } from './components/modal-no-info/modal-no-info.component';
import { ModalRoadworksComponent } from './components/modal-roadworks/modal-roadworks.component';
import { ModalSuccessComponent } from './components/modal-success/modal-success.component';
import { ModalTrafficComponent } from './components/modal-traffic/modal-traffic.component';
import { ModalCameraComponent } from './components/modal-camera/modal-camera.component';
import { NgModule } from '@angular/core';
import { PageTitleComponent } from './controls/page-title/page-title.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { PanelRoadSituationsComponent } from './components/panel-road-situations/panel-road-situations.component';
import { PanelTrafficComponent } from './components/panel-traffic/panel-traffic.component';
import { RendererComponent } from './controls/renderer/renderer.component';
import { ScrollHandlerDirective } from './directives/scroll-handler.directive';
import { SideMenuComponent } from './components/side-menu/side-menu.component';
import { SpinnerComponent } from './controls/spinner/spinner.component';
import { StateIndicatorComponent } from './controls/state-indicator/state-indicator.component';
import { SheetBottomDirective } from './directives/sheet-bottom.directive';
import { MapConventionsComponent } from './components/map-conventions/map-conventions.component';
import { NgChartsModule } from 'ng2-charts';
import { SitBarChartComponent } from './components/sit-bar-chart/sit-bar-chart.component';
import { GraphicLineComponent } from './components/graphic-line/graphic-line.component';
import { SitChartColumnComponent } from './components/sit-chart-column/sit-chart-column.component';
import { SitChartLineColorComponent } from './components/sit-chart-line-color/sit-chart-line-color.component';
import { SitChartSeriesComponent } from './components/sit-chart-series/sit-chart-series.component';
import { SpeedometerComponent } from './components/speedometer/speedometer.component';
import { IndicatorsComponent } from './controls/indicators/indicators.component';
import { ModalCo2Component } from './components/modal-co2/modal-co2.component';
import { ModalLuminaryComponent } from './components/modal-luminary/modal-luminary.component';
import { ModalLuminaryMaintenanceComponent } from './components/modal-luminary-maintenance/modal-luminary-maintenance.component';
import { ModalGarbageComponent } from './components/modal-garbage/modal-garbage.component';
import { PanelCo2Component } from './components/panel-co2/panel-co2.component';
import { PanelLuminaryComponent } from './components/panel-luminary/panel-luminary.component';
import { PanelGarbageComponent } from './components/panel-garbage/panel-garbage.component';
import { PanelTrafficSpeedrangeComponent } from './components/panel-traffic-speedrange/panel-traffic-speedrange.component';
import { PanelTrafficConcordanceComponent } from './components/panel-traffic-concordance/panel-traffic-concordance.component';
import { ModalTrafficSpeedrangeComponent } from './components/modal-traffic-speedrange/modal-traffic-speedrange.component';
import { ModalTrafficConcordanceComponent } from './components/modal-traffic-concordance/modal-traffic-concordance.component';
import { GenericFormComponent } from './components/generic-form/generic-form.component';
import { ModalBicyclePathComponent } from './components/modal-bicycle-path/modal-bicycle-path.component';
import { ModalSuccesUserComponent } from './components/modal-succes-user/modal-succes-user.component';
import { ModalParkingLotComponent } from './components/modal-parking-lot/modal-parking-lot.component';
import { ModalForgotPassComponent } from './components/modal-forgot-pass/modal-forgot-pass.component';
import { ModalTrafficLightComponent } from './components/modal-traffic-light/modal-traffic-light.component';
import { ModalChangePasswordComponent } from './components/modal-change-password/modal-change-password.component';
import { LocationControlFromApiComponent } from './components/location-control-from-api/location-control-from-api.component';
import { ModalForgotPasswordComponent } from './components/modal-forgot-password/modal-forgot-password.component';
import { ModalAforoComponent } from './components/modal-aforo/modal-aforo.component';
import { PanelAforoComponent } from './components/panel-aforo/panel-aforo.component';
import { PanelAgentsComponent } from './components/panel-agents/panel-agents.component';
import { ModalAgentsComponent } from './components/modal-agents/modal-agents.component';
import { AutocompleteControlComponent } from './components/autocomplete-control/autocomplete-control.component';
import { MapFilterComponent } from './components/map-filters/map-filter.component';
import { MapFilterAgentsComponent } from './components/map-filters/agents/map-filter-agents.component';
import { MapFilterAgentsHistoricalComponent } from './components/map-filters/agents-historical/map-filter-agents-historical.component';
import { ModalTrafficManagmentComponent } from './components/modal-traffic-managment/modal-traffic-managment.component';
import { ModalStopBusComponent } from './components/modal-stop-bus/modal-stop-bus.component';
import { MapFilterIncidentsComponent } from './components/map-filters/incidents/map-filter-incidents.component';
import { ModalZonesComponent } from './components/modal-zones/modal-zones.component';
import { ModalRoadRunComponent } from './components/modal-road-run/modal-road-run.component';
import { PanelEditarPmvComponent } from '@ui-core/components/panel-editar-pmv/panel-editar-pmv.component';
import { PanelConsultaPmvComponent } from '@ui-core/components/panel-consulta-pmv/panel-consulta-pmv.component';
import { CreateMessageComponent } from './components/panel-editar-pmv/create-message/create-message.component';
import { ListProgramMessageComponent } from './components/panel-editar-pmv/list-programs-message/list-message.component';
import { ProgramMessageComponent } from './components/panel-editar-pmv/program-message/program-message.component';
import { EditProgramMessageComponent } from './components/panel-editar-pmv/edit-program-message/edit-program-message.component';
import { StateToogleComponent } from './controls/state-toogle/state-toogle.component';
import { PanelAccidentComponent } from './components/panel-accident/panel-accident.component';
import { PanelRuntDatexComponent } from './components/panel-runt-datex/panel-runt-datex.component';
import { ModalRuntDatexComponent } from './components/modal-runt-datex/modal-runt-datex.component';
import { ModalSuccesRolComponent } from './components/modal-succes-rol/modal-succes-rol.component';
import { ListCardPageComponent } from './components/list-card-page/list-card-page.component';
import { ListCardsComponent } from './controls/list-cards/list-cards.component';
import { CardMenuComponent } from './controls/card-menu/card-menu.component';
import { GridButtonIconComponent } from './components/grid-button-icon/grid-button-icon.component';
import { PanelMatrixOdComponent } from './components/panel-matrix-od/panel-matrix-od.component';
import { PanelMatrixOdCameraComponent } from './components/panel-matrix-od-camera/panel-matrix-od-camera.component';
import { MapFilterMatrixODComponent } from './components/map-filters/matrix-od/map-filter-matrix-od.component';
import { MapFilterMatrixODCameraComponent } from './components/map-filters/matrix-odCamera/map-filter-matrix-od-camera.component';
import { MapFilterPeriodMatrixODComponent } from './components/map-filters/period-matrix-od/map-filter-period-matrix-od.component';
import { MapFilterLegendMatrixODComponent } from './components/map-filters/legend-matrix-od/map-filter-legend-matrix-od.component';
import { ChipsComponent } from './components/chips/chips.component';
import { ChipsButtonFilterComponent } from './controls/chips-button-filter/chips-button-filter.component';
import { DropdownButtonComponent } from './controls/dropdown-button/dropdown-button.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { PanelAuditInfoComponent } from './components/panel-audit-info/panel-audit-info.component';
import { SearchAuditRecordComponent } from './components/search-audit-record/search-audit-record.component';
import { SearchAuditUserComponent } from './components/search-audit-user/search-audit-user.component';
import { ListCardAuditComponent } from './controls/list-card-audit/list-card-audit.component';
import { ListCardAuditPageComponent } from './components/list-card-audit-page/list-card-audit-page.component';
import { GridAuditUserComponent } from './components/grid-audit-user/grid-audit-user.component';
import { GridAuditRecordComponent } from './components/grid-audit-record/grid-audit-record.component';
import { AuditBreadcrumbComponent } from './components/audit-breadcrumb/audit-breadcrumb.component';
import { MapFilterBusZoneComponent } from './components/map-filters/bus-zone/map-filter-bus-zone.component';
import { ModalParkingZoneComponent } from './components/modal-parking-zone/modal-parking-zone.component';
import { MapFilterParkingZoneComponent } from './components/map-filters/parking-zone/map-filter-parking-zone.component';
import { AirQualityIndicatorsComponent } from './components/air-quality-indicators/air-quality-indicators.component';
import { AirQualityModalComponent } from './components/air-quality-modal/air-quality-modal.component';
import { FilterAirQualityComponent } from '@ui-core/components/map-filters/filter-air-quality/filter-air-quality.component';
import { ModalStreetParkingComponent } from './components/modal-street-parking/modal-street-parking.component';
import { MapFilterParkingLoadingComponent } from './components/map-filters/parking-zone-loading/map-filter-parking-loading.component';
import { ToastComponent } from './components/toast/toast.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { NotificationCardComponent } from './components/notification-card/notification-card.component';
import { SitPaginatorComponent } from './components/sit-paginator/sit-paginator.component';
import { SitFilterComponent } from './components/sit-module-filter/sit-filter.component';
import { ActionsPMVComponent } from './components/actions-pmv/actions-pmv.component';
import { LeftMenuComponent } from './components/left-menu/left-menu.component';
import { ModuleFormComponent } from './components/module-form/module-form.component';
import { InputModuleFormComponent } from './components/module-form/input-module-form/input-module-form.component';
import { ModalUndergroundParkingComponent } from './components/modal-underground-parking/modal-underground-parking.component';
import { DropdownFilterComponent } from './components/dropdown-filter/dropdown-filter.component';
import { ModalPmvComponent } from './components/modal-pmv/modal-pmv.component';
import { NotifyEventComponent } from './controls/notify-event/notify-event.component';
import { CardNotificationComponent } from './controls/card-notification/card-notification.component';
import { NotificationContainerComponent } from './components/notification-container/notification-container.component';
import { ListCardsNotificationComponent } from './components/list-cards-notification/list-cards-notification.component';
import { NotificationMenuComponent } from './components/header/notification-menu/notification-menu.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { OverlayModule } from '@angular/cdk/overlay';
import { OverlayComponent } from './components/overlay/overlay.component';
import { ImageDetailComponent } from './components/modal-aforo/image-detail/image-detail.component';
import { MapFilterParkingSquarePmrComponent } from './components/map-filters/parking-square-pmr/map-filter-parking-square-pmr.component';
import { NotifyEventCameraComponent } from './controls/notify-event/notify-event-camera/notify-event-camera.component';
import { MapFilterPeriodMatrixODCameraComponent } from './components/map-filters/period-matrix-od-camera/map-filter-period-matrix-od-camera.component';
import { DropdownButtonDatePickerComponent } from './controls/dropdown-button-date-picker/dropdown-button-date-picker.component';
import { CardsPageComponent } from './components/cards-page/cards-page.component';
import { ModalPanicButtonComponent } from './components/modal-panic-button/modal-panic-button.component';
import { PanelPanicButtonComponent } from './components/panel-panic-button/panel-panic-button.component';
@NgModule({
  declarations: [
    CardsPageComponent,
    DropdownButtonDatePickerComponent,
    ButtonComponent,
    CardCamerasComponent,
    CardRoadSituationsComponent,
    CardTrafficComponent,
    DragDropDirective,
    DropdownComponent,
    DropFilesComponent,
    DropFilesComponent,
    DropFilesComponent,
    DynamicFilterComponent,
    DynamicSideMenuComponent,
    FiltersComponent,
    FooterComponent,
    GridPageComponent,
    GridTableComponent,
    HeaderComponent,
    HorizontalMenuComponent,
    IconButtonComponent,
    IconComponent,
    SvgComponent,
    ImgLoaderComponent,
    ListButtonsComponent,
    LoaderOverlayComponent,
    LocationSelectorComponent,
    MapViewerComponent,
    MenuComponent,
    ModalComponent,
    ModalErrorComponent,
    ModalErrorComponent,
    ModalImageComponent,
    ModalNoInfoComponent,
    ModalNoInfoComponent,
    ModalRoadworksComponent,
    ModalSuccessComponent,
    ModalTrafficComponent,
    ModalCameraComponent,
    PageTitleComponent,
    SitPaginatorComponent,
    SitFilterComponent,
    PaginatorComponent,
    PanelRoadSituationsComponent,
    PanelTrafficComponent,
    RendererComponent,
    ScrollHandlerDirective,
    SideMenuComponent,
    SpinnerComponent,
    StateIndicatorComponent,
    SheetBottomDirective,
    MapConventionsComponent,
    SitBarChartComponent,
    GraphicLineComponent,
    SpeedometerComponent,
    SitChartColumnComponent,
    SitChartLineColorComponent,
    SitChartSeriesComponent,
    IndicatorsComponent,
    ModalCo2Component,
    ModalLuminaryComponent,
    ModalLuminaryMaintenanceComponent,
    ModalGarbageComponent,
    PanelCo2Component,
    PanelLuminaryComponent,
    PanelGarbageComponent,
    PanelTrafficSpeedrangeComponent,
    PanelTrafficConcordanceComponent,
    ModalTrafficSpeedrangeComponent,
    ModalTrafficConcordanceComponent,
    GenericFormComponent,
    ModalBicyclePathComponent,
    ModalParkingLotComponent,
    ModalChangePasswordComponent,
    ModalSuccesUserComponent,
    ModalTrafficLightComponent,
    LocationControlFromApiComponent,
    ModalForgotPasswordComponent,
    ModalForgotPassComponent,
    ModalAforoComponent,
    PanelAforoComponent,
    PanelAgentsComponent,
    ModalAgentsComponent,
    MapFilterComponent,
    MapFilterAgentsComponent,
    AutocompleteControlComponent,
    MapFilterAgentsHistoricalComponent,
    ModalTrafficManagmentComponent,
    ModalStopBusComponent,
    MapFilterIncidentsComponent,
    ModalZonesComponent,
    ModalRoadRunComponent,
    PanelEditarPmvComponent,
    PanelConsultaPmvComponent,
    CreateMessageComponent,
    ListProgramMessageComponent,
    ProgramMessageComponent,
    EditProgramMessageComponent,
    StateToogleComponent,
    PanelAccidentComponent,
    PanelRuntDatexComponent,
    ModalRuntDatexComponent,
    ModalSuccesRolComponent,
    ListCardPageComponent,
    ListCardsComponent,
    CardMenuComponent,
    GridButtonIconComponent,
    PanelMatrixOdComponent,
    PanelMatrixOdCameraComponent,
    MapFilterMatrixODComponent,
    MapFilterMatrixODCameraComponent,
    MapFilterPeriodMatrixODComponent,
    MapFilterPeriodMatrixODCameraComponent,
    MapFilterLegendMatrixODComponent,
    ChipsComponent,
    ChipsButtonFilterComponent,
    DropdownButtonComponent,
    BreadcrumbComponent,
    PanelAuditInfoComponent,
    SearchAuditRecordComponent,
    SearchAuditUserComponent,
    ListCardAuditComponent,
    ListCardAuditPageComponent,
    GridAuditUserComponent,
    GridAuditRecordComponent,
    AuditBreadcrumbComponent,
    MapFilterBusZoneComponent,
    ModalParkingZoneComponent,
    ModalPanicButtonComponent,
    MapFilterParkingZoneComponent,
    MapFilterParkingSquarePmrComponent,
    AirQualityIndicatorsComponent,
    AirQualityModalComponent,
    FilterAirQualityComponent,
    ModalStreetParkingComponent,
    MapFilterParkingLoadingComponent,
    ToastComponent,
    NotificationsComponent,
    NotificationCardComponent,
    ActionsPMVComponent,
    LeftMenuComponent,
    ModuleFormComponent,
    InputModuleFormComponent,
    ModalUndergroundParkingComponent,
    DropdownFilterComponent,
    ModalPmvComponent,
    NotifyEventComponent,
    CardNotificationComponent,
    NotificationContainerComponent,
    ListCardsNotificationComponent,
    NotificationMenuComponent,
    OverlayComponent,
    ImageDetailComponent,
    NotifyEventComponent,
    NotifyEventCameraComponent,
    PanelPanicButtonComponent,
  ],
  exports: [
    CardsPageComponent,
    ButtonComponent,
    CardCamerasComponent,
    CardRoadSituationsComponent,
    CardTrafficComponent,
    CardTrafficComponent,
    DropdownComponent,
    DropFilesComponent,
    DropFilesComponent,
    DropFilesComponent,
    DynamicFilterComponent,
    DynamicSideMenuComponent,
    FiltersComponent,
    FooterComponent,
    GridPageComponent,
    GridTableComponent,
    HeaderComponent,
    IconButtonComponent,
    IconComponent,
    SvgComponent,
    ImgLoaderComponent,
    ListButtonsComponent,
    OverlayComponent,
    LoaderOverlayComponent,
    ModuleFormComponent,
    MapViewerComponent,
    ModalComponent,
    PageTitleComponent,
    PaginatorComponent,
    SitPaginatorComponent,
    SitFilterComponent,
    SideMenuComponent,
    ScrollHandlerDirective,
    SitBarChartComponent,
    GraphicLineComponent,
    SitChartColumnComponent,
    SitChartLineColorComponent,
    SitChartSeriesComponent,
    SpeedometerComponent,
    ModalForgotPasswordComponent,
    GenericFormComponent,
    ListCardPageComponent,
    GridButtonIconComponent,
    BreadcrumbComponent,
    PanelAuditInfoComponent,
    SearchAuditRecordComponent,
    SearchAuditUserComponent,
    GridAuditUserComponent,
    GridAuditRecordComponent,
    AuditBreadcrumbComponent,
    ToastComponent,
    MapFilterParkingSquarePmrComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    OverlayModule,
    MaterialModule,
    ReactiveFormsModule,
    NgChartsModule,
    ScrollingModule
  ],
})
export class UiCoreModule {}
